import React from 'react';
import { brandLogos, storeInfo } from '../data/mockData';
import { MapPin, MessageCircle, Phone, Navigation } from 'lucide-react';

const BrandMarquee = () => {
  const doubled = [...brandLogos, ...brandLogos];
  return (
    <div className="mt-8">
      <p className="text-gray-400 text-sm text-center mb-4">Premium imported brands available in-store</p>
      <div className="overflow-hidden relative">
        <div className="flex animate-marquee gap-12 items-center">
          {doubled.map((brand, i) => (
            <div key={i} className="flex-shrink-0 bg-white/10 backdrop-blur-sm rounded-lg px-4 py-2">
              <img
                src={brand.src}
                alt={brand.name}
                className="h-10 w-auto max-w-[100px] object-contain"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const HeroSection = () => (
  <section id="home" className="relative min-h-[90vh] flex items-center overflow-hidden">
    {/* Background */}
    <div className="absolute inset-0">
      <img
        src="https://images.unsplash.com/photo-1553273058-03f8445d9f2e?w=1920&h=1080&fit=crop"
        alt="Vaping lifestyle"
        className="w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/90 via-black/75 to-black/50" />
    </div>

    <div className="relative z-10 max-w-7xl mx-auto px-6 py-20 w-full">
      {/* Location Badge */}
      <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 py-2 mb-6">
        <MapPin size={14} className="text-[#c8ff00]" />
        <span className="text-gray-300 text-sm">Westgate Shopping Centre, Roodepoort</span>
      </div>

      {/* Heading */}
      <h1 className="text-5xl md:text-7xl font-bold leading-tight mb-6">
        <span className="text-white">Stayfly Smokers</span><br />
        <span className="text-[#c8ff00]">Vape, Smoke &amp;</span><br />
        <span className="text-[#c8ff00]">Cannabis</span><br />
        <span className="text-[#c8ff00]">Accessories</span>
      </h1>

      <p className="text-gray-300 text-lg max-w-xl mb-8 leading-relaxed">
        Your premium destination for quality vaping products, smoking essentials, and cannabis accessories. Expert advice, wide selection, friendly service.
      </p>

      <BrandMarquee />

      {/* CTAs */}
      <div className="flex flex-wrap gap-4 mt-8">
        <a
          href={storeInfo.contact.whatsapp}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 bg-[#c8ff00] text-black font-semibold px-6 py-3 rounded-xl hover:bg-[#b8ef00] transition-colors duration-200"
        >
          <MessageCircle size={18} />
          WhatsApp Us
        </a>
        <a
          href={storeInfo.contact.phoneLink}
          className="inline-flex items-center gap-2 border border-[#555] text-white px-6 py-3 rounded-xl hover:border-[#c8ff00] hover:text-[#c8ff00] transition-colors duration-200"
        >
          <Phone size={18} />
          Call the Store
        </a>
        <a
          href={storeInfo.contact.directions}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 border border-[#555] text-white px-6 py-3 rounded-xl hover:border-[#c8ff00] hover:text-[#c8ff00] transition-colors duration-200"
        >
          <Navigation size={18} />
          Get Directions
        </a>
      </div>

      <div className="mt-6 text-gray-400 text-sm">
        <p>Mon-Sat: 8:00 AM - 9:00 PM</p>
        <p>Sun: 8:00 AM - 8:00 PM</p>
      </div>
    </div>
  </section>
);

export default HeroSection;
